'use client';

import { FC, useEffect } from 'react';

export interface JsonLdOrganizationProps {
    orgData: JsonLdOrganizationData,
}

export interface JsonLdOrganizationData {
    '@context': 'https://schema.org'
    '@type': string,
    legalName: string,
    name: string,
    url: string,
    description: string,
    sameAs?: string[],
    logo: string,
    address: {
        addressCountry: string,
        addressLocality: string,
        addressRegion: string,
        streetAddress: string,
        postalCode: string,
    },
    contactPoint?: {
        email?: string,
        telephone?: string,
        availableLanguage: {
            '@type': 'Language',
            name: string,
        }[],
    },
    iso6523Code: string,
    vatID: string,
    foundingDate: string,
}

const ELEMENT_ID = 'structuredOrgData';

export const JsonLdOrganization: FC<JsonLdOrganizationProps> = ({ orgData }) => {
  useEffect(() => {
    // .text is treated as a literal string by the browser (no HTML parsing),
    // so there's no XSS surface even if orgData contains '<' or '</script>'.
    const existing = document.getElementById(ELEMENT_ID);
    if (existing) existing.remove();
    const s = document.createElement('script');
    s.id = ELEMENT_ID;
    s.type = 'application/ld+json';
    s.text = JSON.stringify(orgData);
    document.head.appendChild(s);
    return () => {
      document.getElementById(ELEMENT_ID)?.remove();
    };
  }, [orgData]);

  return null;
};
